export default __webpack_public_path__ + "static/media/6.783b7b5e.png";